var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',_vm._b({attrs:{"loading":_vm.field.loading,"disabled":_vm.field.loading},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}},'v-select',_vm.currentProperties(),false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }